import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TRMConfiguration from './configuration';
import {
  getTRMConfigurations,
  unMountTRMConfigurations,
  putTRMConfigurations
} from '../../../redux/actions/trm/systemConfiguration';

function mapStateToProps(state) {
  const { data, isLoading, hasError, isSaved } = state.trmConfigurations;
  return {
    configurations: data,
    isLoading,
    hasError,
    isSaved
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        getTRMConfigurations,
        unMountTRMConfigurations,
        putTRMConfigurations
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TRMConfiguration);
